document.addEventListener('DOMContentLoaded', ()=> {
    
        
        if (document.querySelectorAll('.js-waypoint').length > 0) {
            const menu = document.querySelectorAll('.js-menu');
            const observerElements = document.querySelectorAll('.js-waypoint');
            const observerOptions = {
                root: null,
                rootMargin: '-49% 10px',
                threshold: 0
            };
            
            const Observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.intersectionRatio > 0) {
                            let id = entry.target.id;
                            
                            for (let i = 0; i < menu.length; i++) {
                                
                                for (let j = 0; j < menu[i].querySelectorAll('[data-target]').length; j++) {
                                    menu[i].querySelectorAll('[data-target]')[j].classList.remove('is-active');
                                }
                                
                                //navmagenta[i]. classList.remove('is-active');
                            }
                            
                            setTimeout(() => {
                                for (let i = 0; i < menu.length; i++) {
                                    menu[i].querySelector("a[data-target='#"+id+"']") ? menu[i].querySelector("a[data-target='#"+id+"']").classList.add('is-active') : false;
                                }
                            }, 10);
                        }
                        
                    });
                }, 
                observerOptions
            );
    
            observerElements.forEach(el => {
                Observer.observe(el);
            });
        }
    
    
}, false);
